/**
 * Centralized Yjs loader to prevent duplicate imports
 * This ensures Yjs is only loaded once across the entire application
 */

// Import using proper npm packages instead of ESM.sh to avoid conflicts
import * as Y from 'yjs'
import { WebrtcProvider } from 'y-webrtc'
import { IndexeddbPersistence } from 'y-indexeddb'
import { WebsocketProvider } from 'y-websocket'

// Single instance to prevent multiple imports
let yjsInstance = null

/**
 * Get the centralized Yjs instance and providers
 * This prevents the "Yjs was already imported" error
 */
export async function getYjsInstance() {
  if (yjsInstance) {
    return yjsInstance
  }

  // Create single instance with all required providers
  yjsInstance = {
    Y,
    WebrtcProvider,
    IndexeddbPersistence,
    WebsocketProvider
  }

  console.log('📦 Yjs instance created (centralized)', {
    hasY: !!yjsInstance.Y,
    hasWebrtc: !!yjsInstance.WebrtcProvider,
    hasIndexeddb: !!yjsInstance.IndexeddbPersistence,
    hasWebsocket: !!yjsInstance.WebsocketProvider
  })

  return yjsInstance
}

/**
 * Reset the Yjs instance (useful for testing)
 */
export function resetYjsInstance() {
  yjsInstance = null
}

// Export individual components for convenience
export { Y, WebrtcProvider, IndexeddbPersistence, WebsocketProvider }
